import React from 'react';
import { ArrowLeft, Share2, Edit, Heart, User, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { openWebRedirect } from '../../../lib/api';

interface ProfileHeaderProps {
  onShare: () => void;
  onEdit?: () => void;
  onToggleLike?: () => void;
  isOwnProfile: boolean;
  isLiked?: boolean;
  username?: string;
  userInfo?: any;
  isModal?: boolean;
  onModalClose?: () => void;
}

export function ProfileHeader({
  onShare,
  onEdit,
  onToggleLike,
  isOwnProfile,
  isLiked,
  username,
  userInfo,
  isModal = false,
  onModalClose
}: ProfileHeaderProps) {
  const navigate = useNavigate();

  const handleOpenProfile = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (username) {
      openWebRedirect(`https://pvtistes.net/membre/${username}/`, userInfo);
    }
  };

  const handleBack = () => {
    if (isModal && onModalClose) {
      onModalClose();
    } else {
      navigate('/matching');
    }
  };

  if (isModal) {
    return null;
  }

  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm border-b border-gray-200/50 dark:border-gray-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Retour aux profils</span>
          </button>
          <div className="flex items-center gap-2 sm:gap-4">
            {username && !isOwnProfile && (
              <button
                onClick={handleOpenProfile}
                className="flex items-center gap-2 px-3 py-2 text-primary-600 dark:text-primary-400 hover:bg-primary-50 dark:hover:bg-primary-900/20 rounded-lg transition-colors"
              >
                <User className="w-5 h-5" />
                <span className="hidden sm:inline font-medium">Profil pvtistes.net</span>
                <ExternalLink className="w-4 h-4" />
              </button>
            )}

            {!isOwnProfile && onToggleLike && (
              <button
                onClick={onToggleLike}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                  isLiked
                    ? 'text-pink-600 dark:text-pink-400 bg-pink-50 dark:bg-pink-900/20 hover:bg-pink-100 dark:hover:bg-pink-900/30'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                <Heart className={`w-5 h-5 ${isLiked ? 'fill-current' : ''}`} />
                <span className="hidden sm:inline font-medium">{isLiked ? 'Je n\'aime plus' : 'J\'aime'}</span>
              </button>
            )}

            {isOwnProfile && onEdit && (
              <button
                onClick={onEdit}
                className="flex items-center gap-2 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
              >
                <Edit className="w-5 h-5" />
                <span className="hidden sm:inline font-medium">Modifier</span>
              </button>
            )}
            <button
              onClick={onShare}
              className="flex items-center gap-2 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <Share2 className="w-5 h-5" />
              <span className="hidden sm:inline font-medium">Partager</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}